import React from 'react';
import { ArrowUturnLeftIcon, ArrowUturnRightIcon } from '@heroicons/react/24/outline';

/**
 * UndoRedo Component
 * 
 * Undo/Redo action buttons
 */
const UndoRedo = ({ onUndo, onRedo, canUndo, canRedo }) => {
  return (
    <div className="flex items-center gap-1 border-r border-gray-300 pr-3">
      <button
        onClick={onUndo}
        disabled={!canUndo}
        className={`
          p-2 rounded-lg transition-colors
          ${
            canUndo
              ? 'hover:bg-gray-100 text-gray-700'
              : 'text-gray-300 cursor-not-allowed'
          }
        `}
        title="Undo (Cmd+Z)"
      >
        <ArrowUturnLeftIcon className="h-5 w-5" />
      </button>

      <button
        onClick={onRedo}
        disabled={!canRedo}
        className={`
          p-2 rounded-lg transition-colors
          ${
            canRedo
              ? 'hover:bg-gray-100 text-gray-700'
              : 'text-gray-300 cursor-not-allowed'
          }
        `}
        title="Redo (Cmd+Shift+Z)"
      >
        <ArrowUturnRightIcon className="h-5 w-5" />
      </button>
    </div>
  );
};

export default UndoRedo;


